// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AuthenticatedRouteRouteImport } from './routes/_authenticated/route'
import { Route as AdvertiseRouteImport } from './routes/advertise'
import { Route as AuthRouteImport } from './routes/auth'
import { Route as CommunityRouteImport } from './routes/community'
import { Route as SellRouteImport } from './routes/sell'
import { Route as TrendsRouteImport } from './routes/trends'
import { Route as UnsubscribeRouteImport } from './routes/unsubscribe'
import { Route as AuthenticatedAdminRouteImport } from './routes/_authenticated/admin'
import { Route as AuthenticatedCollectionRouteImport } from './routes/_authenticated/collection'
import { Route as AuthenticatedDashboardRouteImport } from './routes/_authenticated/dashboard'
import { Route as AuthenticatedDisputesRouteImport } from './routes/_authenticated/disputes'
import { Route as AuthenticatedMyAuctionsRouteImport } from './routes/_authenticated/my-auctions'
import { Route as AuthenticatedMyBidsRouteImport } from './routes/_authenticated/my-bids'
import { Route as AuthenticatedNotificationsRouteImport } from './routes/_authenticated/notifications'
import { Route as AuthenticatedOrderCentreRouteImport } from './routes/_authenticated/order-centre'
import { Route as AuthenticatedOrdersRouteImport } from './routes/_authenticated/orders'
import { Route as AuthenticatedWantListRouteImport } from './routes/_authenticated/want-list'
import { Route as AuthenticatedWatchlistRouteImport } from './routes/_authenticated/watchlist'
import { Route as AccessoriesSlugRouteImport } from './routes/accessories.$slug'
import { Route as AdvertiseApplyRouteImport } from './routes/advertise.apply'
import { Route as AuctionSlugRouteImport } from './routes/auction.$slug'
import { Route as AuctionsIndexRouteImport } from './routes/auctions.index'
import { Route as AuctionsIdRouteImport } from './routes/auctions.$id'
import { Route as AuthResetRouteImport } from './routes/auth_.reset'
import { Route as CardsMasterIdRouteImport } from './routes/cards.$masterId'
import { Route as CollectionsIndexRouteImport } from './routes/collections.index'
import { Route as CollectionsSlugRouteImport } from './routes/collections.$slug'
import { Route as CommunityIndexRouteImport } from './routes/community.index'
import { Route as EventsIndexRouteImport } from './routes/events.index'
import { Route as EventsSlugRouteImport } from './routes/events.$slug'
import { Route as LegalBuyerTermsRouteImport } from './routes/legal/buyer-terms'
import { Route as LegalCookiesRouteImport } from './routes/legal/cookies'
import { Route as LegalPrivacyRouteImport } from './routes/legal/privacy'
import { Route as LegalRefundsRouteImport } from './routes/legal/refunds'
import { Route as LegalSellerAgreementRouteImport } from './routes/legal/seller-agreement'
import { Route as LegalTermsRouteImport } from './routes/legal/terms'
import { Route as NewsletterUnsubscribeRouteImport } from './routes/newsletter.unsubscribe'
import { Route as PartnersIndexRouteImport } from './routes/partners.index'
import { Route as PartnersSlugRouteImport } from './routes/partners.$slug'
import { Route as PartnersApplyRouteImport } from './routes/partners.apply'
import { Route as RegistryIndexRouteImport } from './routes/registry.index'
import { Route as SellerSellerIdRouteImport } from './routes/seller.$sellerId'
import { Route as ShopsIndexRouteImport } from './routes/shops.index'
import { Route as ShopsSlugRouteImport } from './routes/shops.$slug'
import { Route as VerifyCodeRouteImport } from './routes/verify.$code'
import { Route as AuthenticatedDisputesDisputeIdRouteImport } from './routes/_authenticated/disputes.$disputeId'
import { Route as AuthenticatedOrdersSuccessRouteImport } from './routes/_authenticated/orders.success'
import { Route as AuthenticatedSellerIndexRouteImport } from './routes/_authenticated/seller.index'
import { Route as AuthenticatedSellerBillingRouteImport } from './routes/_authenticated/seller.billing'
import { Route as AuthenticatedSellerScanHistoryRouteImport } from './routes/_authenticated/seller.scan-history'
import { Route as AuthenticatedSellerShippedRouteImport } from './routes/_authenticated/seller.shipped'
import { Route as AuthenticatedSellerShippingRouteImport } from './routes/_authenticated/seller.shipping'
import { Route as AuthenticatedSettingsProfileRouteImport } from './routes/_authenticated/settings.profile'
import { Route as CommunityArticlesIndexRouteImport } from './routes/community.articles.index'
import { Route as CommunityArticlesSlugRouteImport } from './routes/community.articles.$slug'
import { Route as CommunityDealersIndexRouteImport } from './routes/community.dealers.index'
import { Route as CommunityDealersSlugRouteImport } from './routes/community.dealers.$slug'
import { Route as CommunityEventsIndexRouteImport } from './routes/community.events.index'
import { Route as RegistryProviderCertRouteImport } from './routes/registry.$provider.$cert'

const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const AuthenticatedRouteRoute = AuthenticatedRouteRouteImport.update({
            id: '/_authenticated',getParentRoute: () => rootRouteImport
          })
const AdvertiseRoute = AdvertiseRouteImport.update({
            id: '/advertise',path: '/advertise',getParentRoute: () => rootRouteImport
          })
const AuthRoute = AuthRouteImport.update({
            id: '/auth',path: '/auth',getParentRoute: () => rootRouteImport
          })
const CommunityRoute = CommunityRouteImport.update({
            id: '/community',path: '/community',getParentRoute: () => rootRouteImport
          })
const SellRoute = SellRouteImport.update({
            id: '/sell',path: '/sell',getParentRoute: () => rootRouteImport
          })
const TrendsRoute = TrendsRouteImport.update({
            id: '/trends',path: '/trends',getParentRoute: () => rootRouteImport
          })
const UnsubscribeRoute = UnsubscribeRouteImport.update({
            id: '/unsubscribe',path: '/unsubscribe',getParentRoute: () => rootRouteImport
          })
const AuthenticatedAdminRoute = AuthenticatedAdminRouteImport.update({
            id: '/admin',path: '/admin',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedCollectionRoute = AuthenticatedCollectionRouteImport.update({
            id: '/collection',path: '/collection',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedDashboardRoute = AuthenticatedDashboardRouteImport.update({
            id: '/dashboard',path: '/dashboard',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedDisputesRoute = AuthenticatedDisputesRouteImport.update({
            id: '/disputes',path: '/disputes',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedMyAuctionsRoute = AuthenticatedMyAuctionsRouteImport.update({
            id: '/my-auctions',path: '/my-auctions',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedMyBidsRoute = AuthenticatedMyBidsRouteImport.update({
            id: '/my-bids',path: '/my-bids',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedNotificationsRoute = AuthenticatedNotificationsRouteImport.update({
            id: '/notifications',path: '/notifications',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedOrderCentreRoute = AuthenticatedOrderCentreRouteImport.update({
            id: '/order-centre',path: '/order-centre',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedOrdersRoute = AuthenticatedOrdersRouteImport.update({
            id: '/orders',path: '/orders',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedWantListRoute = AuthenticatedWantListRouteImport.update({
            id: '/want-list',path: '/want-list',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedWatchlistRoute = AuthenticatedWatchlistRouteImport.update({
            id: '/watchlist',path: '/watchlist',getParentRoute: () => AuthenticatedRouteRoute
          })
const AccessoriesSlugRoute = AccessoriesSlugRouteImport.update({
            id: '/accessories/$slug',path: '/accessories/$slug',getParentRoute: () => rootRouteImport
          })
const AdvertiseApplyRoute = AdvertiseApplyRouteImport.update({
            id: '/apply',path: '/apply',getParentRoute: () => AdvertiseRoute
          })
const AuctionSlugRoute = AuctionSlugRouteImport.update({
            id: '/auction/$slug',path: '/auction/$slug',getParentRoute: () => rootRouteImport
          })
const AuctionsIndexRoute = AuctionsIndexRouteImport.update({
            id: '/auctions/',path: '/auctions/',getParentRoute: () => rootRouteImport
          })
const AuctionsIdRoute = AuctionsIdRouteImport.update({
            id: '/auctions/$id',path: '/auctions/$id',getParentRoute: () => rootRouteImport
          })
const AuthResetRoute = AuthResetRouteImport.update({
            id: '/auth_/reset',path: '/auth/reset',getParentRoute: () => rootRouteImport
          })
const CardsMasterIdRoute = CardsMasterIdRouteImport.update({
            id: '/cards/$masterId',path: '/cards/$masterId',getParentRoute: () => rootRouteImport
          })
const CollectionsIndexRoute = CollectionsIndexRouteImport.update({
            id: '/collections/',path: '/collections/',getParentRoute: () => rootRouteImport
          })
const CollectionsSlugRoute = CollectionsSlugRouteImport.update({
            id: '/collections/$slug',path: '/collections/$slug',getParentRoute: () => rootRouteImport
          })
const CommunityIndexRoute = CommunityIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => CommunityRoute
          })
const EventsIndexRoute = EventsIndexRouteImport.update({
            id: '/events/',path: '/events/',getParentRoute: () => rootRouteImport
          })
const EventsSlugRoute = EventsSlugRouteImport.update({
            id: '/events/$slug',path: '/events/$slug',getParentRoute: () => rootRouteImport
          })
const LegalBuyerTermsRoute = LegalBuyerTermsRouteImport.update({
            id: '/legal/buyer-terms',path: '/legal/buyer-terms',getParentRoute: () => rootRouteImport
          })
const LegalCookiesRoute = LegalCookiesRouteImport.update({
            id: '/legal/cookies',path: '/legal/cookies',getParentRoute: () => rootRouteImport
          })
const LegalPrivacyRoute = LegalPrivacyRouteImport.update({
            id: '/legal/privacy',path: '/legal/privacy',getParentRoute: () => rootRouteImport
          })
const LegalRefundsRoute = LegalRefundsRouteImport.update({
            id: '/legal/refunds',path: '/legal/refunds',getParentRoute: () => rootRouteImport
          })
const LegalSellerAgreementRoute = LegalSellerAgreementRouteImport.update({
            id: '/legal/seller-agreement',path: '/legal/seller-agreement',getParentRoute: () => rootRouteImport
          })
const LegalTermsRoute = LegalTermsRouteImport.update({
            id: '/legal/terms',path: '/legal/terms',getParentRoute: () => rootRouteImport
          })
const NewsletterUnsubscribeRoute = NewsletterUnsubscribeRouteImport.update({
            id: '/newsletter/unsubscribe',path: '/newsletter/unsubscribe',getParentRoute: () => rootRouteImport
          })
const PartnersIndexRoute = PartnersIndexRouteImport.update({
            id: '/partners/',path: '/partners/',getParentRoute: () => rootRouteImport
          })
const PartnersSlugRoute = PartnersSlugRouteImport.update({
            id: '/partners/$slug',path: '/partners/$slug',getParentRoute: () => rootRouteImport
          })
const PartnersApplyRoute = PartnersApplyRouteImport.update({
            id: '/partners/apply',path: '/partners/apply',getParentRoute: () => rootRouteImport
          })
const RegistryIndexRoute = RegistryIndexRouteImport.update({
            id: '/registry/',path: '/registry/',getParentRoute: () => rootRouteImport
          })
const SellerSellerIdRoute = SellerSellerIdRouteImport.update({
            id: '/seller/$sellerId',path: '/seller/$sellerId',getParentRoute: () => rootRouteImport
          })
const ShopsIndexRoute = ShopsIndexRouteImport.update({
            id: '/shops/',path: '/shops/',getParentRoute: () => rootRouteImport
          })
const ShopsSlugRoute = ShopsSlugRouteImport.update({
            id: '/shops/$slug',path: '/shops/$slug',getParentRoute: () => rootRouteImport
          })
const VerifyCodeRoute = VerifyCodeRouteImport.update({
            id: '/verify/$code',path: '/verify/$code',getParentRoute: () => rootRouteImport
          })
const AuthenticatedDisputesDisputeIdRoute = AuthenticatedDisputesDisputeIdRouteImport.update({
            id: '/$disputeId',path: '/$disputeId',getParentRoute: () => AuthenticatedDisputesRoute
          })
const AuthenticatedOrdersSuccessRoute = AuthenticatedOrdersSuccessRouteImport.update({
            id: '/success',path: '/success',getParentRoute: () => AuthenticatedOrdersRoute
          })
const AuthenticatedSellerIndexRoute = AuthenticatedSellerIndexRouteImport.update({
            id: '/seller/',path: '/seller/',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedSellerBillingRoute = AuthenticatedSellerBillingRouteImport.update({
            id: '/seller/billing',path: '/seller/billing',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedSellerScanHistoryRoute = AuthenticatedSellerScanHistoryRouteImport.update({
            id: '/seller/scan-history',path: '/seller/scan-history',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedSellerShippedRoute = AuthenticatedSellerShippedRouteImport.update({
            id: '/seller/shipped',path: '/seller/shipped',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedSellerShippingRoute = AuthenticatedSellerShippingRouteImport.update({
            id: '/seller/shipping',path: '/seller/shipping',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedSettingsProfileRoute = AuthenticatedSettingsProfileRouteImport.update({
            id: '/settings/profile',path: '/settings/profile',getParentRoute: () => AuthenticatedRouteRoute
          })
const CommunityArticlesIndexRoute = CommunityArticlesIndexRouteImport.update({
            id: '/articles/',path: '/articles/',getParentRoute: () => CommunityRoute
          })
const CommunityArticlesSlugRoute = CommunityArticlesSlugRouteImport.update({
            id: '/articles/$slug',path: '/articles/$slug',getParentRoute: () => CommunityRoute
          })
const CommunityDealersIndexRoute = CommunityDealersIndexRouteImport.update({
            id: '/dealers/',path: '/dealers/',getParentRoute: () => CommunityRoute
          })
const CommunityDealersSlugRoute = CommunityDealersSlugRouteImport.update({
            id: '/dealers/$slug',path: '/dealers/$slug',getParentRoute: () => CommunityRoute
          })
const CommunityEventsIndexRoute = CommunityEventsIndexRouteImport.update({
            id: '/events/',path: '/events/',getParentRoute: () => CommunityRoute
          })
const RegistryProviderCertRoute = RegistryProviderCertRouteImport.update({
            id: '/registry/$provider/$cert',path: '/registry/$provider/$cert',getParentRoute: () => rootRouteImport
          })





const AuthenticatedDisputesRouteChildren = {
  AuthenticatedDisputesDisputeIdRoute: AuthenticatedDisputesDisputeIdRoute
}

const AuthenticatedDisputesRouteWithChildren = AuthenticatedDisputesRoute._addFileChildren(AuthenticatedDisputesRouteChildren)




const AuthenticatedOrdersRouteChildren = {
  AuthenticatedOrdersSuccessRoute: AuthenticatedOrdersSuccessRoute
}

const AuthenticatedOrdersRouteWithChildren = AuthenticatedOrdersRoute._addFileChildren(AuthenticatedOrdersRouteChildren)



const AuthenticatedRouteRouteChildren = {
  AuthenticatedAdminRoute: AuthenticatedAdminRoute,AuthenticatedCollectionRoute: AuthenticatedCollectionRoute,AuthenticatedDashboardRoute: AuthenticatedDashboardRoute,AuthenticatedDisputesRoute: AuthenticatedDisputesRouteWithChildren,AuthenticatedMyAuctionsRoute: AuthenticatedMyAuctionsRoute,AuthenticatedMyBidsRoute: AuthenticatedMyBidsRoute,AuthenticatedNotificationsRoute: AuthenticatedNotificationsRoute,AuthenticatedOrderCentreRoute: AuthenticatedOrderCentreRoute,AuthenticatedOrdersRoute: AuthenticatedOrdersRouteWithChildren,AuthenticatedWantListRoute: AuthenticatedWantListRoute,AuthenticatedWatchlistRoute: AuthenticatedWatchlistRoute,AuthenticatedSellerBillingRoute: AuthenticatedSellerBillingRoute,AuthenticatedSellerScanHistoryRoute: AuthenticatedSellerScanHistoryRoute,AuthenticatedSellerShippedRoute: AuthenticatedSellerShippedRoute,AuthenticatedSellerShippingRoute: AuthenticatedSellerShippingRoute,AuthenticatedSettingsProfileRoute: AuthenticatedSettingsProfileRoute,AuthenticatedSellerIndexRoute: AuthenticatedSellerIndexRoute
}

const AuthenticatedRouteRouteWithChildren = AuthenticatedRouteRoute._addFileChildren(AuthenticatedRouteRouteChildren)




const AdvertiseRouteChildren = {
  AdvertiseApplyRoute: AdvertiseApplyRoute
}

const AdvertiseRouteWithChildren = AdvertiseRoute._addFileChildren(AdvertiseRouteChildren)




const CommunityRouteChildren = {
  CommunityIndexRoute: CommunityIndexRoute,CommunityArticlesSlugRoute: CommunityArticlesSlugRoute,CommunityDealersSlugRoute: CommunityDealersSlugRoute,CommunityArticlesIndexRoute: CommunityArticlesIndexRoute,CommunityDealersIndexRoute: CommunityDealersIndexRoute,CommunityEventsIndexRoute: CommunityEventsIndexRoute
}

const CommunityRouteWithChildren = CommunityRoute._addFileChildren(CommunityRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,AuthenticatedRouteRoute: AuthenticatedRouteRouteWithChildren,AdvertiseRoute: AdvertiseRouteWithChildren,AuthRoute: AuthRoute,CommunityRoute: CommunityRouteWithChildren,SellRoute: SellRoute,TrendsRoute: TrendsRoute,UnsubscribeRoute: UnsubscribeRoute,AccessoriesSlugRoute: AccessoriesSlugRoute,AuctionSlugRoute: AuctionSlugRoute,AuctionsIdRoute: AuctionsIdRoute,AuthResetRoute: AuthResetRoute,CardsMasterIdRoute: CardsMasterIdRoute,CollectionsSlugRoute: CollectionsSlugRoute,EventsSlugRoute: EventsSlugRoute,LegalBuyerTermsRoute: LegalBuyerTermsRoute,LegalCookiesRoute: LegalCookiesRoute,LegalPrivacyRoute: LegalPrivacyRoute,LegalRefundsRoute: LegalRefundsRoute,LegalSellerAgreementRoute: LegalSellerAgreementRoute,LegalTermsRoute: LegalTermsRoute,NewsletterUnsubscribeRoute: NewsletterUnsubscribeRoute,PartnersSlugRoute: PartnersSlugRoute,PartnersApplyRoute: PartnersApplyRoute,SellerSellerIdRoute: SellerSellerIdRoute,ShopsSlugRoute: ShopsSlugRoute,VerifyCodeRoute: VerifyCodeRoute,AuctionsIndexRoute: AuctionsIndexRoute,CollectionsIndexRoute: CollectionsIndexRoute,EventsIndexRoute: EventsIndexRoute,PartnersIndexRoute: PartnersIndexRoute,RegistryIndexRoute: RegistryIndexRoute,ShopsIndexRoute: ShopsIndexRoute,RegistryProviderCertRoute: RegistryProviderCertRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)